(function () {
  'use strict'
  var definer = $('<div dir="rtl" style="font-size: 14px; width: 4px; height: 1px; position: absolute; top: -1000px; overflow: scroll">ABCD</div>').appendTo('body')[0]
  var type = 'reverse'

  if (definer.scrollLeft > 0) {
    type = 'default'
  } else {
    definer.scrollLeft = 1
    if (definer.scrollLeft === 0) {
      type = 'negative'
    }
  }

  $(definer).remove()
  $.support.rtlScrollType = type
}())

if (!window.focusListenersAttached) {
  (function () {
    window.focusListenersAttached = true

    var hidden = 'hidden'

    // Standards:
    if (hidden in document) {
      document.addEventListener('visibilitychange', onchange)
    } else if ((hidden = 'mozHidden') in document) {
      document.addEventListener('mozvisibilitychange', onchange)
    } else if ((hidden = 'webkitHidden') in document) {
      document.addEventListener('webkitvisibilitychange', onchange)
    } else if ((hidden = 'msHidden') in document) {
      document.addEventListener('msvisibilitychange', onchange)
      // IE 9 and lower:
    } else if ('onfocusin' in document) {
      document.onfocusin = document.onfocusout = onchange
      // All others:
    } else {
      window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange
    }

    function onchange(evt) {
      var v = 'visible'
      var h = 'hidden'
      var evtMap = {
        focus: v, focusin: v, pageshow: v, blur: h, focusout: h, pagehide: h
      }

      evt = evt || window.event
      if (evt.type in evtMap) {
        document.body.className = evtMap[evt.type]
      } else {
        document.body.className = this[hidden] ? h : v
      }

      if (document.body.className === v) {
        $(window).trigger('window-active')
      }
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined) {
      onchange({ type: document[hidden] ? 'blur' : 'focus' })
    }
  })()
}
